/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function PawIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="paw"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M12 10.625C10.757 10.625 9.603 11.27 8.952 12.328L8.497 13.067C8.175 13.591 7.687 13.992 7.112 14.208C5.492 14.815 4.82 16.742 5.71 18.225L5.724 18.248C6.452 19.461 7.972 19.938 9.262 19.357L10.319 18.881C11.388 18.4 12.612 18.4 13.681 18.881L14.738 19.357C16.028 19.938 17.548 19.461 18.276 18.248L18.29 18.225C19.18 16.742 18.508 14.815 16.888 14.208C16.313 13.992 15.825 13.591 15.503 13.067L15.048 12.328C14.397 11.27 13.243 10.625 12 10.625Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <circle cx={15} cy={6.197} r={1.803} stroke={color} fill="none" data-stroke-tone="primary" />
          <circle cx={19.303} cy={10.5} r={1.803} stroke={color} fill="none" data-stroke-tone="primary" />
          <circle cx={9} cy={6.197} r={1.803} stroke={color} fill="none" data-stroke-tone="primary" />
          <circle cx={4.697} cy={10.5} r={1.803} stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
